"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyOneWayTransfer = void 0;
const verifyTransferLeg_1 = require("./verifyTransferLeg");
const verifyOneWayTransfer = (legs) => {
    return (0, verifyTransferLeg_1.verifyTransferLeg)(legs.outbound) || false;
};
exports.verifyOneWayTransfer = verifyOneWayTransfer;
